import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { systemMetadata } from '@mysidewalk/references';

import DimensionAttributionDetails from 'attribution/DimensionAttributionDetails';
import PageNotFound from 'application/PageNotFound';

import 'styles/layouts.css';

const { DimensionDynamicAttribution, Dimension } = systemMetadata;

const DIMENSION_PARAMS = {
  include: 'description',
};

function DimensionAttributionRoute() {
  const { id } = useParams();

  const query = useQuery(
    ['dimensions/attribution', id],
    () => (
      Promise.all([
        Dimension.retrieve(id, DIMENSION_PARAMS),
        DimensionDynamicAttribution.retrieve(id),
      ])
    ),
  );

  useEffect(() => {
    if (query.isSuccess) {
      const [dimension] = query.data;
      document.title = `${dimension.friendlyName} | mySidewalk Catalog`;
    }
  }, [query]);

  if (query.isError) return <PageNotFound />;

  const hasLoaded = query.isSuccess;
  const [dimension, attribution] = query.data ?? [];

  const header = (
    hasLoaded
      ? (
        <header className="indicator-summary">
          <h1 className="indicator-summary__title">{dimension.friendlyName}</h1>
        </header>
      )
      : null
  );
  const details = (
    hasLoaded
      ? (
        <DimensionAttributionDetails
          dimension={dimension}
          attribution={attribution}
        />
      )
      : null
  );

  return (
    <div className="layout--page">
      {header}
      {details}
    </div>
  );
}

export default DimensionAttributionRoute;
